import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";
import { PageInfoBar } from "@components/common/page-info-bar";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { CreateTeam } from "@pages/members/teams/create-team";
import { TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
import { useAppSelector } from "@store/store-helper";
import {
  fetchingTeamsFlagsSelector,
  teamsSelector,
} from "@store/teams/teams-selector";

/**
 * Shows the main details for the teams
 */
export function TeamsDetails(): JSX.Element {
  const teams = useAppSelector(teamsSelector);
  const { status } = useAppSelector(fetchingTeamsFlagsSelector);
  const { canCreateNewTeam } = useHasUserValidRoleCompanyLevel();

  if (status === "pending") {
    return <PageInfoBar isLoading={true} />;
  }

  return (
    <PageInfoBar
      items={[
        {
          content: (
            <FaroTextField
              label={`Total ${TEAMS_DISPLAY_NAME}`}
              initialValue={teams.length}
              faroVariant="main"
              fontSize="18px"
            />
          ),
        },
      ]}
      action={{
        content: <CreateTeam />,
        isHidden: !canCreateNewTeam,
      }}
    />
  );
}
